import styled from 'styled-components';
import { CONTAINER_QUERY_BREAKPOINTS } from '../../types';

export const LocationLabel = styled.div`
  font-size: 14px;
  line-height: 1.14;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  font-style: normal;
  font-weight: 400;

  color: #17181a;
`;

export const Row = styled.div<{ parentWidth?: number }>`
  display: flex;
  flex-direction: column;
  margin-bottom: 4px;
  > :first-child {
    margin-bottom: 4px;
  }

  ${({ parentWidth }) => {
    if (parentWidth && parentWidth >= CONTAINER_QUERY_BREAKPOINTS.minMd) {
      return `
        flex-direction: row;
        align-items: center;
        flex-wrap: nowrap;
        > :first-child {
          margin-bottom: 0px;
          margin-right: 8px;
        }
      `;
    }
    return '';
  }}
`;
